
import { config, configmain } from "../config";

// ==============================MasterChecker=============================

// ====================RetrieveCheckermodify RDM and BDM and DEM for 3 pages 1.  =====================

export const getUrlParam = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
};

const apiSessionId = sessionStorage.getItem("sessionId");
console.log("sessionId", apiSessionId);

export const getConfigRetrivalApprove = (paramValue, approveRowId) => ({
  headers: {
    "userId": localStorage.getItem('userid')
  },
  params: {
    "tableName": paramValue,
    "rowId": approveRowId,
    "approveStatus": "Y",
    "dataModel": "MASTERS",
    "rejectedReason": "",
  }
});

export const getConfigRetrivalReject = (paramValue, clickedRowId, rejectedReason, notificationType) => ({
  headers: {
    "userId": localStorage.getItem('userid')
  },
  params: {
    "tableName": paramValue,
    "rowId": clickedRowId,
    "approveStatus": "N",
    "rejectedReason": rejectedReason,
    "dataModel": "MASTERS",
    "Notifications": notificationType,
  }
});



export const getConfig_Retrieve = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get('param');

  return {
    headers: { "userId": localStorage.getItem('userid') },
    params: { "tableName": `${paramValue}_retrieved` }
  };
};


// =================================================END===================================================================
// =======================Start --Mastertabledetails========================================================


export const MastertabledetailsConfig = (fileName) => {
  return {
    headers: { "userId": localStorage.getItem('userid') },
    params: { "tableName": fileName }
  };
};

// const config = MastertabledetailsConfig(fileName);

// =====================================================
// config.js

// Approve the Param 

export const MastertabledetailsApproveconfig = (file) => {
  return {
    headers: {
      "userId": localStorage.getItem('userid'),
    },
    params: {
      "tableName": file,
      "status": 1,
      "dataModel": "Masters",
      "rejectedReason": "",
    },
  };
};

// Mastertabledetailsconfig = createConfig(file);

// ==========RejectConfig=========
export const MastertabledetailsRejectconfig = (file, clickedRowId, rejectedReason, notificationType) => {
  return {
    headers: {
      "userId": localStorage.getItem('userid'),
    },
    params: {
      "rowId": clickedRowId,
      "tableName": file,
      "status": 0,
      "dataModel": "MASTERS",
      "rejectedReason": rejectedReason,
      "Notifications": notificationType,
    },
  };
};
// const config = MastertabledetailsRejectconfig(file, clickedRowId, rejectedReason, notificationType);
// ===========================================================================================================

// ================END --Mastertabledetails================================================================================================


// **********************************************************************************************************************************
const filterRejectedRecords = (data) => {
  return data.filter(item => (
    item.Rejected_Reason !== "Ready for validation. (updated)" &&
    item.Rejected_Reason !== "\\N" &&
    item.Rejected_Reason !== "" && item.Rejected_Reason !== "\N") && (
      item.active_yn !== 'N' && item.active_yn !== "N"
    ));
};


// =======================================================================================================



// ************************Render Table for templates -BDM and DEM checker **************************

export const ConfigTemplateChecker = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tablenames = urlParams.get('fileName');

  return {
    headers: {
      "userId": localStorage.getItem('userid'),
    },
    params: {
      "tableName": tablenames,
    },
  };
};

// const config = ConfigTemplateChecker();

// ====================Approve Param for CheckerTemplate========================
export const DEMApproveTemplateConfig = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const fileName = urlParams.get('fileName');
  const tableNameWithoutTemp = fileName.replace('_temp.json', '');

  return {
    headers: {
      "userId": localStorage.getItem('userid'),
    },
    params: {
      "tableName": tableNameWithoutTemp,
      "dataModel": "DEM",
      "status": "1",
    },
  };
};


// const config = DEMApproveTemplateConfig();
// ===========================================================
export const BDMApproveTemplateConfig = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const fileName = urlParams.get('fileName');
  const tableNameWithoutTemp = fileName.replace('_temp.json', '');

  const config = {
    headers: { "userId": localStorage.getItem('userid') },
    params: {
      "tableName": tableNameWithoutTemp,
      "dataModel": "BDM",
      "status": "1"
    },
  };
};

// const config = BDMApproveTemplateConfig();
// ============================================================


export const BDMRejectTemplateConfig = (tableNameWithoutTemp, notificationType, selectedColumn, otherReason) => {
  return {
    headers: { "userId": localStorage.getItem('userid') },
    params: {
      "tableName": tableNameWithoutTemp,
      "dataModel": "BDM",
      "Notifications": notificationType,
      "rejectedReason": selectedColumn !== 'Others' ? selectedColumn : otherReason.trim()
    }
  };
};

// const config = getConfig(tableNameWithoutTemp, notificationType, selectedColumn, otherReason);
// =============================================================

export const DEMRejectTemplateConfig = (tableNameWithoutTemp, notificationType, selectedColumn, otherReason) => {
  return {
    headers: { "userId": localStorage.getItem('userid') },
    params: {
      "tableName": tableNameWithoutTemp,
      "dataModel": "DEM",
      "Notifications": notificationType,
      "rejectedReason": selectedColumn !== 'Others' ? selectedColumn : otherReason.trim()
    }
  };
};


// ==========================================================================================================================

{/*-----------------------------Api--------------------------------- */ }
// const baseURL = 'http://172.16.119.156:8081';

// export const PortURL = 'http://172.16.119.156:3001';

const baseURL = config.BASE_URL;  // Use API Base URL
console.log("API Base URL:", baseURL); // Debugging line
export const PortURL = config.PORT_URL;  // Use App Port URL

export const ocrfile = `/node/uploadocrfiles`;

export const mqemocr = `/node/ocrupload`;

export const xlsxfile = `/node/uploadxlsxfiles`;

export const templatedata = `/node/templatedata`;

export const helpDeskToEmailId = "darreshraj@ryzklytix.com";

export const upload3001 = `/node/uploads`;

export const uploadRename = `/node/rename-file`;

export const uploadRename1 = `/node/rename-file1`;

export const uploadMutiple = `/node/uploadsmultiple`;

export const uploadsmodify = `/node/uploadsmodify`;

export const uploadChunk = `/node/upload-chunk`;

export const mergeChunk = `/node/merge-chunks`;

export const emailAttachment = `/node/emailAttachment`;

export const generatereport = `/api/report/generate`;

export const userinfo = `/api/dem/userinfo`;

export const Getlocations = `/api/user/getalllocation`;

export const Getalluser = `/api/admin/getalluserdetails`;

export const Comparision = `/api/report/comparision`;

export const Audit = `/api/report/audit`;

export const audittemplateinfo = `/api/report/audittemplateinfo`;

export const MakerChartreport = `/api/user/makerchartreport`;

export const CheckerChartreport = `/api/user/checkerchartreport`;

export const Useradministration = `/api/admin/getuserdetails`;

export const makertemplatedetails = `/api/user/makertemplatedetails`;

export const demoAireportTexts = `/api/user/demoAireportTexts`;

export const Websocket = `/dgms`;

export const ocrtxtfile = `/node/uploadocrfiles`;

export const OcrWebsocket = `/ocr`;

export const ReportWebsocket = `/report`;

export const OcrReportMethod = `/api/user/demoAiReportTexts`;

export const OcrMethod = `/api/user/demoaiocr`;

export const chatbots = `/api/user/demoAiTexts`;

export const MakerRetrieval = `/api/dem/makRetrieval`;

export const Rejectretrievaldata = `/api/retrieval/rejectrtldata`;

export const Approveretrievaldata = `/api/retrieval/approvertldata`;

export const createTextFileApi = `/node/create-text-file`;

export const pendingnotify = `/api/user/pendingNotify`;

export const processflow = `/api/user/processflow`;

export const Completeddataapi = `/api/dashboard/completedactivites`;

export const ForgetPasswordApi = `/api/user/tempCode`;

export const chatbotupload = `/api/user/tempbulkocr`;

export const ResetPassword1 = `/api/user/resetPassword`;

export const checksumAPI = `/api/dem/checksum`;

export const UserListrdmdata = `/api/user/listrdmdata`;

export const ViewRdmlist = `/api/rdm/viewRdmcheckerlist`;

export const Rdmretrievallist = `/api/rdm/viewrdmretrieval`;

export const demmodifylist = `/api/rdm/modifydata`;

export const demmakermodifylist = `/api/template/makermodifylist`;

export const formdata = `/api/dem/formdata`;

export const checkerassigneddata = `/api/user/checkerassigneddata`;

export const Assigndata = `/api/user/assigndata`;

export const Bulkuploaddata = `/api/bulk/upload`;

export const Template_list_columns = `/api/rb/templatelistcolumns`;

export const UserHierarchy = `/api/user/hierarchy`;

export const FormTextFile = `/node/form-text-file`;

export const DownloadAPi = `/api/rdm/downloaddatardm`;

export const LoginApi = `/api/session/login`;

export const LoginRaf = `/api/user/raflogin`;

export const Livetabledata = `/api/user/raflivetabledata`;

export const LoginCSRF = `/api/csrf`;

export const NotifyApi = `/api/onscreenbell/activities`;

export const LogoutApi = `/api/user/logout`;

export const list_templates = `/api/user/list_templates`;

export const list_deptwisetemplates = `/api/deptWiseTemplates`;

export const Makerlist_deptwisetemplates = `/api/user/makeruploadlist`;

export const Makermodifylisttemplates = `/api/user/makermodifylist`;

export const Makerretrievalmodifylist = `/api/user/viewlivetablelist`;

export const Makerpastmodifylist = `/api/user/modifyretrievallist`;

export const Checkerlist_deptwisetemplates = `/api/user/checkerreviewlist`;

export const Checkerretrievallist = `/api/dem/retrievalcheckerlist`;

export const list_all_users = `/api/user/list_all_users`;

export const checkerassignedtemplates = `/api/user/checkerassignedtemplates`;

export const assign_template = `/api/user/assigntemplate`;

export const assigntemplate = `/api/user/assigntemplate`;

export const demtemplateForm = `/api/dem/demtemplateform`;

export const ListAlldept = `/api/user/getalldepartment`;

export const RoleandMapping = `/api/user/roleparameter`;

export const userWisedept = `/api/dept/userwise`;

export const ColumnOrder = `/api/user/templatecolumnlist`;

export const ListAllusers = `/api/user/listallusers`;

export const OwnershipApi = `/api/user/ownership`;

export const indicatorlist = `/api/user/indicatorlist`;

export const List_Checker = `/api/user/list_checkers`;

export const Checker_list = `/api/user/acmcheckermakerlist`;

export const UpdateUserStatus = `/api/user/update_user_status`;

export const Modify_User = `/api/user/modify_user`;

export const Add_User = `/api/user/adduser`;

export const RBselect_Tables = `/api/rb/select_Tables`;

export const Audittemplatelist = `/api/report/deptwiseaudittemplates`;

export const AllTemplateColumns = `/api/report/getcolumnsforauditrep`;

export const GenerateAuditReport = `/api/report/dynamicauditreport`;

export const CharDate = `/api/rb/char_date_cols`;

export const NumberCols = `/api/rb/num_cols`;

export const Gen_report = `/api/rb/gen_report`;

export const Trend_report = `/api/report/trendanalysisrep`;

export const Comparison_report = `/api/user/executeall`;

export const BackUpTemplateList = `/api/backup/templateslist`;

export const BackupCheckerList = `/api/backup/checkerlist`;

export const backupadmintemplate = `/api/backupadmintemplate/list`;

export const backupsList = `/api/backups/list`;

export const backuprestore = `/api/backuprestore/list`;

export const Backupprelist = `/api/backupprelist/list`;

export const demsubmitdata = `/api/submitdata/dem`;

export const demformdata = `/api/upload/quickdata`;

export const mappingdata = `/api/upload/mappingdata`;

export const shariahconfig = `/api/upload/shariahconfig`;

export const complaintsconfig = `/api/user/bsfcomplaintsmapping`;

export const getcomplaintsconfig = `/api/user/complaintsadminmodify`;

export const getshariahconfig = `/api/user/shariahconfigtable`;

export const operationalvalue = `/api/user/operationalvalue`;

export const shariahmakerretrieval = `/api/user/shariahmakerretrieval`;

export const shariahremarks = `/api/user/shariahremarks`;

export const configdata = `/api/upload/configdata`;

export const demtableattributes = `/api/demtableattributes/dem`;

export const updatetextfile3001 = `/node/update-text-file`;

export const DEMModifytemplate = `/api/modifytemplate/dem`;

export const Modifytemplate = `/api/template/modify`;

export const allowmodifytemplate = `/api/allowmodifytemplate`;

export const rafmapping = `/api/user/rafmapping`;

export const UpdateRetrivevalRdm = `/api/updateRetrieval/rdm`;

export const DeleteretrievalRDM = `/api/deleteRetrieval/rdm`;

export const DeleteretrievalDEM = `/api/deleteRetrieval/dem`;

export const UpdateRetrieveDEM = `/api/updateRetrieval/dem`;

export const UploadDemtemplate = `/api/upload/demtemplate`;

export const Uploadtemplate = `/api/template/upload`;

export const Modifylist = `/api/template/list`;

export const CheckerListApi = `/api/rdm/checkerlist`;

export const updateadminlist = `/api/rdm/updateadminlist`;

export const updatedataApi = `/api/updatedata/dem`;

export const modifypastdata = `/api/user/makerretrieval`;

export const makermodifypastdata = `/api/user/updateRetrieval`;

export const deletedataApi = `/api/deletedata/dem`;

export const pastdatadelete = `/api/user/pastdatadelete`;

export const dataRetrievalPT = `/api/dataRetrievalPT/dem`;

export const uploadrdmdata = `/api/rdm/uploadrdmdata`;

export const uploadbdmdata = `/api/upload/bulkdata`;

export const bulkmodifydata = `/api/uploadmodify/bulkdata`;

export const generateReportApi = `/api/report/dqreport`;

export const Reviewrdmdata = `/api/rdm/reviewrdmdata`;

export const viewrdmdata = `/api/rdm/viewrdmdata`;

export const previewrdmdata = `/api/rdm/previewrdmdata`;

export const updateshariahhistory = `/api/user/updateshariahhistory`;

export const getshariahhistory = `/api/user/getshariahhistory`;

export const updateshariahretrieved = `/api/user/updateshariahretrieved`;

export const updateshariahuploadtosama = `/api/user/updateshariahsama`;

export const updateshariahoverride = `/api/user/updateshariahoverride`;

export const downloadrdmdata = `/api/rdm/downloadrdmdata`;  // 

export const approvrejectretrieval = `/api/approvrejectretrieval/dem`;

export const viewDemTemplate = `/api/dem/viewDemTemplate`;

export const viewCheckerlist = `/api/template/checkerlist`;

export const viewtemplatelist = `/api/template/makerlist`;

export const bdmtablecolumns = `/api/bdmtablecolumns/bdm`;

export const demtablecolumnspreview = `/api/demtablecolumnspreview/dem`;

export const viewDemmodifyTemplate = `/api/dem/viewDemmodifyTemplate`;

export const viewDemRejectedTemplate = `/api/rejtemreason/dem`;

export const demretrievallist = `/api/dem/retrieval_list`;

export const viewDemcheckerTemplateslist = `/api/dem/viewDemcheckerTemplateslist`;

export const demtableattributespreview = `/api/demtableattributespreview/dem`;

export const approveTemplate = `/api/approveTemplate/dem`;

export const rejectTemplate = `/api/rejectTemplate/dem`;

export const approvedatadem = `/api/approveData/dem`;

export const rejecteddatadem = `/api/rejectData/dem`;

export const rejectpastdata = `/api/user/approvrejectretrieval`;

export const approvepastdata = `/api/user/approvrejectretrieval`;
export const checkboxrejectpastdata = `/api/user/rejectcheckboxretrieval`;

export const checkboxapprovepastdata = `/api/user/approvecheckboxretrieval`;

export const rejectbulkpastdata = `/api/user/bulkrejectretrieval`;

export const approvebulkpastdata = `/api/user/bulkapproveretrieval`;

export const approverdmdata = `/api/rdm/approverdmdata`;

export const rejectrdmdata = `/api/rdm/rejectrdmdata`;

export const checkboxreject = `/api/bdm/checkboxreject`;

export const shariahmapping = `/api/user/shariahmappingdata`;

export const shariahmappingdata = `/api/user/shariahdata`;

export const shariahadminmapping = `/api/user/shariahadminmodify`;

export const checkboxapprove = `/api/approvecheckboxData/dem`;

export const viewrestoretemplete = `/api/backup/viewrestoretemplete`;

export const backupdelete = `/api/backup/delete`;

export const backuprestoretempalte = `/api/backup/restoretempalte`;

export const backuptemplatecheckerlist = `/api/backuptemplate/checkerlist`;

export const backupcheckerinitiallist = `/api/backupcheckerinitial/list`;
export const portfolioReportList = `/api/user/portfolioreportlist`;
export const portfolioReport = `/api/user/portfolioreport`;

export const demretrieval_list = `/api/dem/retrieval_list`;

export const BackupcheckerListapi = `/api/backupchecker/list`;

export const backuprestoredata = `/api/backup/restoredata`;

export const backuprejectrdm = `/api/backup/rejectrdm`;

export const bellIconClick = `/api/user/updateActiveStatus`;

export const dataretrieval_list = `/api/dem/dataretrieval_list`;

export const reviewretrieval_list = `/api/dem/reviewretrieval_list`;

export const modifyretrieval_list = `/api/dem/modifyretrieval_list`;

export const hierarchy_user = `/api/hierarchy/user`;

export const dropdownlist = `/api/user/rdmdropdown`;

export const helpDeskEmailApi = `/api/send`;

export const dropdownlistApi = `/api/user/rdmdropdown`;

export const residualSaveApi = `/api/user/templateworkflow`;

export const residualListApi = `/api/user/getTemplateWorkflow`;

// const baseURL = config.BASE_URL;     // http://localhost:8081
// const PortURL = config.PORT_URL;     // http://localhost:3001

// /* ================= NODE (3001) ================= */
// export const ocrfile = `${PortURL}/node/uploadocrfiles`;
// export const mqemocr = `${PortURL}/node/ocrupload`;
// export const xlsxfile = `${PortURL}/node/uploadxlsxfiles`;
// export const templatedata = `${PortURL}/node/templatedata`;
// export const upload3001 = `${PortURL}/node/uploads`;
// export const uploadRename = `${PortURL}/node/rename-file`;
// export const uploadRename1 = `${PortURL}/node/rename-file1`;
// export const uploadMutiple = `${PortURL}/node/uploadsmultiple`;
// export const uploadsmodify = `${PortURL}/node/uploadsmodify`;
// export const uploadChunk = `${PortURL}/node/upload-chunk`;
// export const mergeChunk = `${PortURL}/node/merge-chunks`;
// export const emailAttachment = `${PortURL}/node/emailAttachment`;
// export const createTextFileApi = `${PortURL}/node/create-text-file`;

// /* ================= JAVA (8081) ================= */
// export const generatereport = `${baseURL}/api/report/generate`;
// export const userinfo = `${baseURL}/api/dem/userinfo`;
// export const Getlocations = `${baseURL}/api/user/getalllocation`;
// export const Getalluser = `${baseURL}/api/admin/getalluserdetails`;
// export const Comparision = `${baseURL}/api/report/comparision`;
// export const Audit = `${baseURL}/api/report/audit`;
// export const audittemplateinfo = `${baseURL}/api/report/audittemplateinfo`;
// export const MakerChartreport = `${baseURL}/api/user/makerchartreport`;
// export const CheckerChartreport = `${baseURL}/api/user/checkerchartreport`;
// export const Useradministration = `${baseURL}/api/admin/getuserdetails`;
// export const makertemplatedetails = `${baseURL}/api/user/makertemplatedetails`;
// export const demoAireportTexts = `${baseURL}/api/user/demoAireportTexts`;
// export const OcrReportMethod = `${baseURL}/api/user/demoAiReportTexts`;
// export const OcrMethod = `${baseURL}/api/user/demoaiocr`;
// export const chatbots = `${baseURL}/api/user/demoAiTexts`;
// export const MakerRetrieval = `${baseURL}/api/dem/makRetrieval`;
// export const Rejectretrievaldata = `${baseURL}/api/retrieval/rejectrtldata`;
// export const Approveretrievaldata = `${baseURL}/api/retrieval/approvertldata`;
// export const pendingnotify = `${baseURL}/api/user/pendingNotify`;
// export const processflow = `${baseURL}/api/user/processflow`;
// export const Completeddataapi = `${baseURL}/api/dashboard/completedactivites`;
// export const ForgetPasswordApi = `${baseURL}/api/user/tempCode`;
// export const chatbotupload = `${baseURL}/api/user/tempbulkocr`;
// export const ResetPassword1 = `${baseURL}/api/user/resetPassword`;
// export const checksumAPI = `${baseURL}/api/dem/checksum`;
// export const UserListrdmdata = `${baseURL}/api/user/listrdmdata`;
// export const ViewRdmlist = `${baseURL}/api/rdm/viewRdmcheckerlist`;
// export const Rdmretrievallist = `${baseURL}/api/rdm/viewrdmretrieval`;
// export const demmodifylist = `${baseURL}/api/rdm/modifydata`;
// export const demmakermodifylist = `${baseURL}/api/template/makermodifylist`;
// export const formdata = `${baseURL}/api/dem/formdata`;
// export const checkerassigneddata = `${baseURL}/api/user/checkerassigneddata`;
// export const Assigndata = `${baseURL}/api/user/assigndata`;

// export const Bulkuploaddata = `${baseURL}/api/bulk/upload`;
// export const Template_list_columns = `${baseURL}/api/rb/templatelistcolumns`;
// export const UserHierarchy = `${baseURL}/api/user/hierarchy`;
// export const DownloadAPi = `${baseURL}/api/rdm/downloaddatardm`;
// export const LoginApi = `${baseURL}/api/session/login`;
// export const LoginCSRF = `${baseURL}/api/csrf`;
// export const NotifyApi = `${baseURL}/api/onscreenbell/activities`;
// export const LogoutApi = `${baseURL}/api/user/logout`;
// export const list_templates = `${baseURL}/api/user/list_templates`;
// export const list_deptwisetemplates = `${baseURL}/api/deptWiseTemplates`;
// export const Makerlist_deptwisetemplates = `${baseURL}/api/user/makeruploadlist`;
// export const Makermodifylisttemplates = `${baseURL}/api/user/makermodifylist`;
// export const Makerretrievalmodifylist = `${baseURL}/api/user/viewlivetablelist`;
// export const Makerpastmodifylist = `${baseURL}/api/user/modifyretrievallist`;
// export const Checkerlist_deptwisetemplates = `${baseURL}/api/user/checkerreviewlist`;
// export const Checkerretrievallist = `${baseURL}/api/dem/retrievalcheckerlist`;
// export const list_all_users = `${baseURL}/api/user/list_all_users`;
// export const checkerassignedtemplates = `${baseURL}/api/user/checkerassignedtemplates`;
// export const assign_template = `${baseURL}/api/user/assigntemplate`;
// export const assigntemplate = `${baseURL}/api/user/assigntemplate`;
// export const demtemplateForm = `${baseURL}/api/dem/demtemplateform`;
// export const ListAlldept = `${baseURL}/api/user/getalldepartment`;
// export const userWisedept = `${baseURL}/api/dept/userwise`;
// export const ColumnOrder = `${baseURL}/api/user/templatecolumnlist`;
// export const ListAllusers = `${baseURL}/api/user/listallusers`;
// export const List_Checker = `${baseURL}/api/user/list_checkers`;
// export const Checker_list = `${baseURL}/api/user/acmcheckermakerlist`;
// export const UpdateUserStatus = `${baseURL}/api/user/update_user_status`;
// export const Modify_User = `${baseURL}/api/user/modify_user`;
// export const Add_User = `${baseURL}/api/user/adduser`;
// export const RBselect_Tables = `${baseURL}/api/rb/select_Tables`;
// export const Audittemplatelist = `${baseURL}/api/report/deptwiseaudittemplates`;
// export const AllTemplateColumns = `${baseURL}/api/report/getcolumnsforauditrep`;
// export const GenerateAuditReport = `${baseURL}/api/report/dynamicauditreport`;
// export const CharDate = `${baseURL}/api/rb/char_date_cols`;
// export const NumberCols = `${baseURL}/api/rb/num_cols`;
// export const Gen_report = `${baseURL}/api/rb/gen_report`;
// export const Trend_report = `${baseURL}/api/report/trendanalysisrep`;
// export const Comparison_report = `${baseURL}/api/user/executeall`;
// export const BackUpTemplateList = `${baseURL}/api/backup/templateslist`;
// export const BackupCheckerList = `${baseURL}/api/backup/checkerlist`;
// export const backupadmintemplate = `${baseURL}/api/backupadmintemplate/list`;
// export const backupsList = `${baseURL}/api/backups/list`;
// export const backuprestore = `${baseURL}/api/backuprestore/list`;
// export const Backupprelist = `${baseURL}/api/backupprelist/list`;
// export const demsubmitdata = `${baseURL}/api/submitdata/dem`;
// export const demformdata = `${baseURL}/api/upload/quickdata`;
// export const demtableattributes = `${baseURL}/api/demtableattributes/dem`;
// export const DEMModifytemplate = `${baseURL}/api/modifytemplate/dem`;
// export const Modifytemplate = `${baseURL}/api/template/modify`;
// export const allowmodifytemplate = `${baseURL}/api/allowmodifytemplate`;
// export const UpdateRetrivevalRdm = `${baseURL}/api/updateRetrieval/rdm`;
// export const DeleteretrievalRDM = `${baseURL}/api/deleteRetrieval/rdm`;
// export const DeleteretrievalDEM = `${baseURL}/api/deleteRetrieval/dem`;
// export const UpdateRetrieveDEM = `${baseURL}/api/updateRetrieval/dem`;
// export const UploadDemtemplate = `${baseURL}/api/upload/demtemplate`;
// export const Uploadtemplate = `${baseURL}/api/template/upload`;
// export const Modifylist = `${baseURL}/api/template/list`;
// export const CheckerListApi = `${baseURL}/api/rdm/checkerlist`;
// export const updateadminlist = `${baseURL}/api/rdm/updateadminlist`;
// export const updatedataApi = `${baseURL}/api/updatedata/dem`;
// export const modifypastdata = `${baseURL}/api/user/makerretrieval`;
// export const makermodifypastdata = `${baseURL}/api/user/updateRetrieval`;
// export const deletedataApi = `${baseURL}/api/deletedata/dem`;
// export const pastdatadelete = `${baseURL}/api/user/pastdatadelete`;
// export const dataRetrievalPT = `${baseURL}/api/dataRetrievalPT/dem`;
// export const uploadrdmdata = `${baseURL}/api/rdm/uploadrdmdata`;
// export const uploadbdmdata = `${baseURL}/api/upload/bulkdata`;
// export const bulkmodifydata = `${baseURL}/api/uploadmodify/bulkdata`;
// export const generateReportApi = `${baseURL}/api/report/dqreport`;
// export const Reviewrdmdata = `${baseURL}/api/rdm/reviewrdmdata`;
// export const viewrdmdata = `${baseURL}/api/rdm/viewrdmdata`;
// export const previewrdmdata = `${baseURL}/api/rdm/previewrdmdata`;
// export const downloadrdmdata = `${baseURL}/api/rdm/downloadrdmdata`;
// export const approvrejectretrieval = `${baseURL}/api/approvrejectretrieval/dem`;
// export const viewDemTemplate = `${baseURL}/api/dem/viewDemTemplate`;
// export const viewCheckerlist = `${baseURL}/api/template/checkerlist`;
// export const viewtemplatelist = `${baseURL}/api/template/makerlist`;
// export const bdmtablecolumns = `${baseURL}/api/bdmtablecolumns/bdm`;
// export const demtablecolumnspreview = `${baseURL}/api/demtablecolumnspreview/dem`;
// export const viewDemmodifyTemplate = `${baseURL}/api/dem/viewDemmodifyTemplate`;
// export const viewDemRejectedTemplate = `${baseURL}/api/rejtemreason/dem`;
// export const demretrievallist = `${baseURL}/api/dem/retrieval_list`;
// export const viewDemcheckerTemplateslist = `${baseURL}/api/dem/viewDemcheckerTemplateslist`;
// export const demtableattributespreview = `${baseURL}/api/demtableattributespreview/dem`;
// export const approveTemplate = `${baseURL}/api/approveTemplate/dem`;
// export const rejectTemplate = `${baseURL}/api/rejectTemplate/dem`;
// export const approvedatadem = `${baseURL}/api/approveData/dem`;
// export const rejecteddatadem = `${baseURL}/api/rejectData/dem`;
// export const rejectpastdata = `${baseURL}/api/user/approvrejectretrieval`;
// export const approvepastdata = `${baseURL}/api/user/approvrejectretrieval`;
// export const checkboxrejectpastdata = `${baseURL}/api/user/rejectcheckboxretrieval`;
// export const checkboxapprovepastdata = `${baseURL}/api/user/approvecheckboxretrieval`;
// export const rejectbulkpastdata = `${baseURL}/api/user/bulkrejectretrieval`;
// export const approvebulkpastdata = `${baseURL}/api/user/bulkapproveretrieval`;
// export const approverdmdata = `${baseURL}/api/rdm/approverdmdata`;
// export const rejectrdmdata = `${baseURL}/api/rdm/rejectrdmdata`;
// export const checkboxreject = `${baseURL}/api/bdm/checkboxreject`;
// export const checkboxapprove = `${baseURL}/api/approvecheckboxData/dem`;
// export const viewrestoretemplete = `${baseURL}/api/backup/viewrestoretemplete`;
// export const backupdelete = `${baseURL}/api/backup/delete`;
// export const backuprestoretempalte = `${baseURL}/api/backup/restoretempalte`;
// export const backuptemplatecheckerlist = `${baseURL}/api/backuptemplate/checkerlist`;
// export const backupcheckerinitiallist = `${baseURL}/api/backupcheckerinitial/list`;
// export const portfolioReportList = `${baseURL}/api/user/portfolioreportlist`;
// export const portfolioReport = `${baseURL}/api/user/portfolioreport`;
// export const demretrieval_list = `${baseURL}/api/dem/retrieval_list`;
// export const BackupcheckerListapi = `${baseURL}/api/backupchecker/list`;
// export const backuprestoredata = `${baseURL}/api/backup/restoredata`;
// export const backuprejectrdm = `${baseURL}/api/backup/rejectrdm`;
// export const bellIconClick = `${baseURL}/api/user/updateActiveStatus`;
// export const dataretrieval_list = `${baseURL}/api/dem/dataretrieval_list`;
// export const reviewretrieval_list = `${baseURL}/api/dem/reviewretrieval_list`;
// export const modifyretrieval_list = `${baseURL}/api/dem/modifyretrieval_list`;
// export const hierarchy_user = `${baseURL}/api/hierarchy/user`;
// export const dropdownlist = `${baseURL}/api/user/rdmdropdown`;
// export const helpDeskEmailApi = `${baseURL}/api/send`;
// export const dropdownlistApi = `${baseURL}/api/user/rdmdropdown`;
// export const helpDeskToEmailId = "darreshraj@ryzklytix.com";
// export const Websocket = `/dgms`;


// export const OcrWebsocket = `/ocr`;

// export const ReportWebsocket = `/report`;
// /* ================= NODE APIs (3001) ================= */

// export const FormTextFile = `${PortURL}/node/form-text-file`;
// export const updatetextfile3001 = `${PortURL}/node/update-text-file`;


export default filterRejectedRecords;

export const toCamelCase = (str) => {
  return str
    .split(' ') // Split by spaces
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize first letter, make the rest lowercase
    )
    .join(' '); // Join back with spaces
};


